/* globals jQuery */
//import { debounce } from 'throttle-debounce'
/**
 * jQueryResponsiveNav module
 *
 * Usage:
 *
 * ```js
 * $.fn.responsiveNav = require('./responsive-nav.jquery.js')
 *
 * $('.my-nav-element').responsiveNav({ options })
 * ```
 */
export default (($) => {

  return function jQueryResponsiveNav( options ) {

    options = $.extend({}, {
      wrapperSelector: '.site-wrapper',
      menuButtonSelector: '.menu-btn',
      menuOpenWrapperClass: 'menu-open',
      activeClass: 'active',
      debounceTime: 150,
    }, options)

    const $this = $(this),
      $wrapper = $( options.wrapperSelector ),
      $menuButton = $( options.menuButtonSelector )


    function _menuIsOpen() {
      //site wrapper has the menu-open class
      return $menuButton.hasClass( options.activeClass )
    }

    //CLOSE THE NAV
    function closeNav() {
      $wrapper.removeClass( options.menuOpenWrapperClass )
      $menuButton.removeClass( options.activeClass )
    }

    //OPEN THE NAV
    function openNav() {
      $wrapper.addClass( options.menuOpenWrapperClass )
      $menuButton.addClass( options.activeClass )
    }

    $menuButton.on( 'touchstart, click', function(event) {

      event.stopPropagation()
      event.preventDefault()

      if ( _menuIsOpen() ) {
        closeNav()
      }
      else{
        openNav()
      }
    }) //end button on

    return this
  }

})(jQuery)
